import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

const ensureMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const ensureCanonical = (href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

function Seo({ title, description, keywords, canonicalPath, schema }: SeoProps) {
  useEffect(() => {
    const base = window.location.origin;
    const canonicalUrl = `${base}${canonicalPath}`;

    document.title = title;
    ensureMeta('name', 'description', description);
    ensureMeta('name', 'keywords', keywords);
    ensureMeta('name', 'robots', 'index,follow');
    ensureMeta('property', 'og:title', title);
    ensureMeta('property', 'og:description', description);
    ensureMeta('property', 'og:url', canonicalUrl);
    ensureMeta('property', 'og:type', 'website');
    ensureMeta('property', 'og:site_name', '网报吃瓜');
    ensureMeta('name', 'twitter:card', 'summary_large_image');
    ensureMeta('name', 'twitter:title', title);
    ensureMeta('name', 'twitter:description', description);
    ensureCanonical(canonicalUrl);

    const scriptId = 'readdy-page-schema';
    document.getElementById(scriptId)?.remove();
    if (schema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalPath, schema]);

  return null;
}

export default Seo;